
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 54 54"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","d":"M0 0h54v54H0z"}}),_c('path',{attrs:{"data-name":"パス 3","d":"M27 4.8c7.2 0 8.1 0 10.8.3a13.89 13.89 0 015.1.9 10.54 10.54 0 015.1 5.1 13.89 13.89 0 01.9 5.1c0 2.7.3 3.6.3 10.8s0 8.1-.3 10.8a13.89 13.89 0 01-.9 5.1 10.54 10.54 0 01-5.1 5.1 13.89 13.89 0 01-5.1.9c-2.7 0-3.6.3-10.8.3s-8.1 0-10.8-.3a13.89 13.89 0 01-5.1-.9A10.54 10.54 0 016 42.9a13.89 13.89 0 01-.9-5.1c0-2.7-.3-3.6-.3-10.8s0-8.1.3-10.8a13.89 13.89 0 01.9-5.1 10.61 10.61 0 012.1-3 5 5 0 013-2.1 13.89 13.89 0 015.1-.9c2.7-.3 3.6-.3 10.8-.3M27 0c-7.2 0-8.4 0-11.1.3a18.62 18.62 0 00-6.6 1.2 11.66 11.66 0 00-4.8 3 11.66 11.66 0 00-3 4.8C.6 11.1.3 12.9.3 15.9 0 18.6 0 19.8 0 27s0 8.4.3 11.1a18.62 18.62 0 001.2 6.6 11.66 11.66 0 003 4.8 11.66 11.66 0 004.8 3 18.4 18.4 0 006.6 1.2c2.7.3 3.9.3 11.1.3s8.4 0 11.1-.3a18.36 18.36 0 006.6-1.2 12.59 12.59 0 007.8-7.8 18.36 18.36 0 001.2-6.6c0-3 .3-3.9.3-11.1s0-8.4-.3-11.1a18.4 18.4 0 00-1.2-6.6 11.66 11.66 0 00-3-4.8 11.66 11.66 0 00-4.8-3A18.62 18.62 0 0038.1.3C35.4 0 34.2 0 27 0m0 13.2A13.58 13.58 0 0013.2 27 13.8 13.8 0 1027 13.2M27 36a8.84 8.84 0 01-9-8.68V27a8.84 8.84 0 018.68-9H27a8.84 8.84 0 019 8.68V27a8.84 8.84 0 01-8.68 9H27M41.4 9.3a3.3 3.3 0 103.3 3.3 3.33 3.33 0 00-3.3-3.3","fill-rule":"evenodd"}})])
          )
        }
      }
    